import { MessageBox, Notification, Message } from "element-ui";
import router from "@/router/index.js";

let isRelogin = false;

// 统一处理未登录状态
export const disposeNologin = () => {
  if (!isRelogin) {
    isRelogin = true;
    MessageBox.confirm(
      "登录状态已过期，您可以继续留在该页面，或者重新登录",
      "系统提示",
      {
        confirmButtonText: "重新登录",
        cancelButtonText: "取消",
        type: "warning",
      }
    )
      .then(() => {
        isRelogin = false;
        localStorage.removeItem("token");
        // router.push("/login");
        window.open(`https://www.appbyt.com/pcPage.html`, "_self");
      })
      .catch(() => {
        isRelogin = false;
      });
  }
};

// 成功回调封装
export const handleSuccess = (res, callback) => {
  const { code, data, msg, status } = res.data || {};
  if (status === 200 || status === 0) {
    callback && callback(data);
  } else if ([11013, 11012, 11011, 11001, 401, 11014].includes(status)) {
    disposeNologin();
  } else if (status === 500) {
    Message.error(msg || "服务器内部错误");
  } else {
    Notification.warning({
      title: "请求异常",
      message: msg || "未知错误",
      duration: 1500,
    });
  }
};

// 错误处理
export const handleError = (error) => {
  let message = error.message;

  if (message === "Network Error") {
    message = "后端接口连接异常";
  } else if (message.includes("timeout")) {
    message = "系统接口请求超时";
  } else if (message.includes("Request failed with status code")) {
    const statusCode = message.slice(-3);
    message = `系统接口 ${statusCode} 异常`;
  }

  console.error("请求失败:", message);
};



// WEBPACK FOOTER //
// ./src/utils/helper.js